// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__uOngi","rotation":"Spinner_rotation__2jJYG","spinner__wrapper":"Spinner_spinner__wrapper__gBizL"};